<template>
  <flat-pickr
      ref="dateTimePicker"
      :value="value"
      class="form-control"
      :id="data.id"
      @input="onInput"
      :placeholder="data.label"
      :config="config"
      :disabled="data.disabled === 'disabled'"
  />
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import field from '@/mixins/field';
    import moment from 'moment'

    export default {
        components: {
            flatPickr,
        },
        mixins: [field],
        data() {
            return {
                compValue: this.value,
                format: "YYYY-MM-DD",
                firstDay: 1,
                config: {
                  altInput: true,
                  weekStart: 1,
                }
            }
        },
        computed: {
            noClearButton() {
                return this.data.required.length > 0;
            }
        },
        methods: {
            onInput(val) {
                this.$emit('input', val)
            }
        },
    }
</script>

<style lang="scss">
@import '~flatpickr/dist/flatpickr.css';

.flatpickr-current-month {
  .flatpickr-monthDropdown-months {
    -webkit-appearance: none;
  }

  .flatpickr-monthDropdown-months,
  .numInputWrapper {
    font-size: 1.1rem;
    border-radius: 4px;
    padding: 2px;
    transition: all 0.15s ease-out;

    span {
      display: none;
    }
  }
}
</style>